import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type PorscheMasterDataModuleSpecsFragment } from '../../../../api/fragments/PorscheMasterDataModuleSpecs';
import InputField from '../../../../components/fields/InputField';
import PasswordField from '../../../../components/fields/PasswordField';
import FormFields from '../../../../themes/admin/Fields/FormFields';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

type PorscheMasterDataModuleUpdateFormProps = {
    module: PorscheMasterDataModuleSpecsFragment;
};

const PorscheMasterDataModuleUpdateForm = ({ module }: PorscheMasterDataModuleUpdateFormProps) => {
    const { t } = useTranslation(['moduleDetails']);

    return (
        <StyledContainer gutter={10}>
            <Col md={8} xs={24}>
                <FormFields.InputField
                    {...t('moduleDetails:fields.displayName', {
                        returnObjects: true,
                    })}
                    name="displayName"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <FormFields.InputField
                    {...t('moduleDetails:fields.ggId', {
                        returnObjects: true,
                    })}
                    name="ggId"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <FormFields.InputField
                    {...t('moduleDetails:fields.ppnUrl', { returnObjects: true })}
                    addonBefore="https://"
                    name="ppnUrl"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <FormFields.InputField
                    {...t('moduleDetails:fields.ppnClientId', { returnObjects: true })}
                    name="ppnClientId"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <PasswordField
                    {...t('moduleDetails:fields.ppnClientSecret', { returnObjects: true })}
                    name="ppnClientSecret"
                    forAdmin
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.ppnResource', { returnObjects: true })}
                    name="ppnResource"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.pccdUrlPrefix', { returnObjects: true })}
                    addonBefore="https://"
                    name="pccdUrlPrefix"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.pccdClientId', { returnObjects: true })}
                    name="pccdClientId"
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <PasswordField
                    {...t('moduleDetails:fields.pccdClientSecret', { returnObjects: true })}
                    name="pccdClientSecret"
                    forAdmin
                    required
                />
            </Col>
            <Col md={8} xs={24}>
                <PasswordField
                    {...t('moduleDetails:fields.pccdToken', { returnObjects: true })}
                    name="pccdToken"
                    forAdmin
                    required
                />
            </Col>
        </StyledContainer>
    );
};

export default PorscheMasterDataModuleUpdateForm;
